import moment from 'moment';

class ExpiresAtController {

  shouldDisplayDate () {
    if (!this.dateTime && this.displayDate) {
      this.displayDate = undefined;
    }

    if (this.dateTime && !this.displayDate) {
      const dateTime = moment(`${this.dateTime}+00:00`);
      let day = 'Today';
      let suffix = ` at ${dateTime.format('h:mma')}`;
      const dateDiff = dateTime.format('YYYYMMDD') - moment().format('YYYYMMDD');

      if(dateDiff > 0) {
        day = 'Tomorrow';
      }

      if(dateDiff < 0) {
        day = 'Basket has expired';
        suffix = '';
      }

      this.displayDate = `${day}${suffix}`;
      this.displayInline = !!this.inline;
    }

    return !!this.displayDate;
  }
}

ExpiresAtController.$inject = [ ];

export default ExpiresAtController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/controllers/expiresAt.controller.js